declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_structural_foo extends $mol_object {
		lol( ): number
		bar( ): ({ 
			'alpha': number,
			'beta': Record<string, any>,
			'xxx': ReturnType< $mol_view_tree2_to_js_test_ex_structural_foo['lol'] >,
		}) 
	}
	
}

//# sourceMappingURL=structural.view.tree.d.ts.map